<template>
<div class="visual-process">
    <h3>{{ produktnaam }}sverzekering</h3>
		<div class="grid-container">

            <step1schademelden-component
                    :ctx="ctx"
                    :schademeldenurl="schademeldenurl"
            ></step1schademelden-component>
			
			<div class="visual-item">
				<div class="hexagon-thick">
					<p class="icon icon-archive clean"></p>
				</div>
				<h4>In behandeling</h4>
				<p>Wij nemen uw schademelding binnen 48 uur in behandeling.</p>
				<a href="#" data-toggle="modal" data-target="#behandelingmodal" >Lees meer</a>
			</div>
			
			<div class="visual-item">
				<div class="hexagon-thick">
					<p class="icon icon-user clean"></p>
				</div>
				<h4>Wacht op uw reactie</h4>
				<p>Voor de afhandeling van uw schade hebben wij aanvullende gegevens van u nodig. Hiervan ontvangt u van ons bericht per e-mail en in uw berichtenbox.</p>
				<a href="#" data-toggle="modal" data-target="#reactiemodal" >Lees meer</a>
			</div>
			
			<div class="visual-item">
				<div class="hexagon-thick">
					<p class="icon icon-check clean"></p>
				</div>
				<h4>Afgehandeld</h4>
				<p>Wij hebben uw dossier gesloten.</p>
			</div>

		</div>


	<!-- Modal in behandeling -->
			<div class="modal fade" id="behandelingmodal" tabindex="-1" role="dialog" aria-hidden="true">
			  <div class="modal-dialog" role="document">
			    <div class="modal-content">
			      <div class="modal-header">
			        <h5 class="modal-title">In behandeling</h5>
			        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
			          <span aria-hidden="true">x</span>
			        </button>
			      </div>
			      <div class="modal-body">
			        <p>Afhankelijk van de situatie nemen wij contact met u of de tegenpartij op. Wij vragen aanvullende informatie bij de tegenpartij op door middel van een vragenformulier.</p>
			        	
			      </div>
			      <div class="modal-footer">
					<button type="button" class="btn btn-primary btn-modal-close">OK</button>	
			      </div>
			    </div>
			  </div>
			</div>
		<!-- end Modal -->

		<!-- Modal uw reactie -->
			<div class="modal fade" id="reactiemodal" tabindex="-1" role="dialog" aria-hidden="true">
			  <div class="modal-dialog" role="document">
			    <div class="modal-content">
			      <div class="modal-header">
			        <h5 class="modal-title">Wacht op uw reactie</h5>
			        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
			          <span aria-hidden="true">x</span>
			        </button>
			      </div>
			      <div class="modal-body">
			        <p>Na ontvangst van het ingevulde vragenformulier of de informatie die we bij u hebben opgevraagd, wordt de aansprakelijkheid beoordeeld. Daarna informeren wij beide partijen over het genomen besluit.</p>
			        	
			      </div>
			      <div class="modal-footer">
					<button type="button" class="btn btn-primary btn-modal-close">OK</button>	
			      </div>
			    </div>
			  </div>
			</div>
		<!-- end Modal -->





</div> 
</template>

<script>
    import step1SchadeMelden from './step1schademelden.vue'


export default {
  name: 'aansprakelijkheid-component',
    components: {
        'step1schademelden-component': step1SchadeMelden
    },
  props: {	  
	  ctx: String,
      produktnaam: String,
      schademeldenurl: String,
  },
  data: function () {
    return {    	
     }
  } 
  
}

</script>




// WEBPACK FOOTER //
// aansprakelijkheid.vue?5f929fa0